/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Past_WeekInputs */



/**
* | output |
* | --- |
* | "Past Week" |
*
* @param {Past_WeekInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const past_week = /** @type {((inputs?: Past_WeekInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Past_WeekInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Semaine passée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte Woche")
	if (locale === "it") return /** @type {LocalizedString} */ ("Settimana scorsa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прошедшая неделя")
	if (locale === "es") return /** @type {LocalizedString} */ ("La semana pasada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("过去一周")
	if (locale === "ja") return /** @type {LocalizedString} */ ("先週")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछले सप्ताह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Semana passada")
	return /** @type {LocalizedString} */ ("Past Week")
});